import styled from "styled-components";
import { PieContainer } from "../Charts/PieChart/PieChart.styled";
import { FunnelContainer } from "../Charts/FunnelChart/FunnelChart.styled";

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: ${({ isOldView }) => (isOldView ? "0px" : "40px 60px")};
  width: 100%;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: ${({ width }) => width || "100%"};
  grid-column: span 2;
  gap: 10px;

  > div {
    flex: 1 1 calc(50% - 10px);
    min-width: 250px;
  }

  @media (max-width: 1200px) {
    flex-direction: column;

    > div {
      flex: 1 1 100%;
    }

    ${PieContainer}, ${FunnelContainer} {
      height: 300px;
    }
  }
`;
